import { DateTime } from 'luxon';
import { AccordionVoidCivilUnion } from 'shell/view-models/accordion-void-civil-union';
// import { AccordionMarriage } from 'shell/view-models/accordion-marriage';
// import { CivilStatusID } from 'shell/constants/civil-status';
import {
  regexalphaNumericWithDotSlash,
  diacriticRegex,
  idActRegex,
  regVolRegex,
} from 'shell/constants/regex';
import * as yup from 'yup';
import { ActType } from 'shell/constants/act-type';
import { DocumentDigital } from 'shell/view-models/act-form';
// import { generalitySchema } from './generality';
// import { personSchema } from './person';

export const voidMarriageSchema = yup.object().shape({
  type: yup.string().required('Campo obbligatorio'),
  courtType: yup.string().required('Campo obbligatorio'),
});

export const civilStatusSchema = yup.object().shape({
  status: yup.string().required('Campo obbligatorio'),
  note: yup.string().nullable(),
  // .when('status', (status, formValidationSchema) =>
  //   status === CivilStatusID.nonClassificabile
  //     ? formValidationSchema.required('Campo obbligatorio')
  //     : formValidationSchema.nullable()
  // ),
});

export const marriageSchema = yup
  .object()
  .nullable()
  .shape({
    // generality: generalitySchema,
    // person: personSchema,
    // isForeign: yup.boolean(),
    // italian: yup.object().when('isForeign', {
    //   is: false,
    //   then: yup.object().shape({
    //     municipality: yup.object().nullable().required().shape({}),
    //     province: yup.string().required('Campo obbligatorio'),
    //   }),
    //   otherwise: yup.object().shape({
    //     municipality: yup.object().notRequired().nullable().shape({}),
    //     province: yup.string().notRequired().nullable(),
    //   }),
    // }),
    // foreign: yup.object().when('isForeign', {
    //   is: true,
    //   then: yup.object().shape({
    //     municipality: yup.object().shape({}).nullable().required('Campo obbligatorio'),
    //     state: yup.object().shape({}).required('Campo obbligatorio').nullable(),
    //   }),
    //   otherwise: yup.object().shape({
    //     municipality: yup.object().shape({}).nullable().notRequired(),
    //     state: yup.object().shape({}).notRequired().nullable(),
    //   }),
    // }),
    italian: yup.object().shape({
      location: yup.string().matches(diacriticRegex, 'Il campo è alfanumerico con diacritico'),
    }),
    foreign: yup.object().shape({
      municipality: yup
        .object()
        .shape({
          // description: yup
          //   .string()
          //   .matches(diacriticRegex, 'Il campo è alfanumerico con diacritico'),
        })
        .nullable(),
    }),
    from: yup
      .date()
      .nullable()
      .typeError('Data non valida')
      .max(DateTime.now(), 'Il campo valido dal non può essere maggiore della data odierna'),
    // year: yup.string().matches(regexYear, 'Il campo deve essere un anno'),
    // portion: yup.string().matches(alphanumericRegex, 'Il campo non è valido'),
    // range: yup.string().matches(alphanumericRegex, 'Il campo non è valido'),
    // documentNumber: yup
    //   .string()
    //   .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri'),
    // regVol: yup.string().matches(alphanumericRegex, 'Il campo non è valido'),
    // documentDate: yup
    //   .date()
    //   .nullable()
    //   .typeError('Data non valida')
    //   .max(DateTime.now(), 'Il campo data atto non può essere maggiore della data odierna'),
    // municipality: yup.object().shape({
    //   description: yup.string(),
    // }),
    // exceptionalLocation: yup
    //   .string()
    //   .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri'),
    // office: yup.string().matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri'),
  });

export const widowhoodSchema = yup
  .object()
  .nullable()
  .shape({
    isForeign: yup.boolean().nullable(),
    italian: yup.object(),
    // documentDate: yup
    //   .date()
    //   .nullable()
    //   .typeError('Data non valida')
    //   .max(DateTime.now(), 'Il campo data atto non può essere maggiore della data odierna')
    //   .min(yup.ref('eventDate'), "Il campo data atto non può essere minore della data dell'evento"),
    actType: yup.string(),
    digital: yup
      .object()
      .nullable()
      .when('actType', {
        is: ActType.AttoDigitale,
        otherwise: yup.object().nullable(),
        then: yup
          .object()
          .nullable()
          .shape({
            idAnsc: yup
              .string()
              .nullable()
              .matches(idActRegex, 'Formato non corretto')
              .test((value) => {
                if (value) {
                  const [year] = value.split('-');
                  const isValid = year ? Number.parseInt(year) >= 2022 : true;

                  return isValid
                    ? true
                    : new yup.ValidationError(
                        "L'idAnsc deve avere anno maggiore al 2022",
                        undefined,
                        'marriage.digital.idAnsc'
                      );
                }
                return true;
              })
              .required('Campo obbligatorio'),
            documentDate: yup
              .date()
              .nullable()
              .notRequired()
              .typeError('Formato non valido')
              .required('Campo obbligatorio'),
            municipality: yup.object().shape({}).nullable().required('Campo obbligatorio'),
          })
          .test((values) => {
            const castedValues = values as unknown as DocumentDigital;

            if (
              castedValues?.municipality?.id &&
              castedValues?.istatCode &&
              castedValues?.municipality?.id === castedValues.istatCode
            ) {
              return true;
            }
            return new yup.ValidationError([
              new yup.ValidationError(
                'Non coincidono i due codici ISTAT',
                undefined,
                'widowhood.digital.municipality'
              ),
              new yup.ValidationError(
                'Non coincidono i due codici ISTAT',
                undefined,
                'widowhood.digital.istatCode'
              ),
            ]);
          }),
      }),
    paper: yup
      .object()
      .nullable()
      .when('actType', {
        is: ActType.AttoCartaceo,
        otherwise: yup.object().nullable(),
        then: yup.object().shape({
          actDate: yup
            .date()
            .nullable()
            .max(
              DateTime.local().plus({ days: 1 }),
              'La data non può essere successiva alla data odierna'
            )
            .typeError('Data non valida'),
          transcribed: yup.string().nullable(),
          actMunicipality: yup.object().nullable().shape({}).required('Campo obbligatorio'),
          actYear: yup
            .number()
            .nullable()
            .required('Campo obbligatorio')
            .typeError('Sono ammesse solamente cifre'),
          actNumber: yup
            .number()
            .nullable()
            .required('Campo obbligatorio')
            .typeError('Sono ammesse solamente cifre'),
          actPart: yup
            .string()
            .nullable()
            .required('Campo obbligatorio')
            .test(
              'part-ammisible-values',
              'Gli unici valori ammessi sono 1 o 2',
              (value) => ['1', '2'].indexOf(value || '') >= 0
            ),
          actSeries: yup.string().nullable(),
          // .required('Campo obbligatorio')
          // .test(
          //   'part-ammisible-values',
          //   'Gli unici valori ammessi sono A, B o C',
          //   (value) => ['A', 'B', 'C'].indexOf(value || '') >= 0
          // ),
          actVolume: yup
            .string()
            .nullable()
            .when('actMunicipality.description', {
              is: (description: string) => (description || '').toLocaleLowerCase() === 'milano',
              then: yup.string().required('Campo obbligatorio').matches(regVolRegex, {
                message: 'Per il comune di Milano il volume è formato da R e due cifre(es. R00)',
              }),
            }),
        }),
      }),
    foreign: yup.object(),
    // year: yup
    //   .string()
    //   .matches(regexYear, 'Il campo deve essere una data')
    //   .required('Campo obbligatorio'),
    // portion: yup
    //   .string()
    //   .required('Campo obbligatorio')
    //   .matches(portionRegex, 'Il campo non è valido'),
    // range: yup.string().matches(seriesRegex, 'Il campo non è valido'),
    // documentNumber: yup
    //   .string()
    //   .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri')
    //   .required('Campo obbligatorio'),
    // regVol: yup.string().matches(volumeRegex, 'Il campo non è valido'),
    eventDate: yup.date().nullable().required('Campo obbligatorio').typeError('Data non valida'),
    // municipality: yup.object().shape({}).nullable().required('Campo obbligatorio'),
  });

export const civilUnionSchema = yup
  .object()
  .nullable()
  .shape({
    // generality: generalitySchema,
    // citizenship: yup.object().shape({}).nullable().required('Campo obbligatorio'),
    eventDate: yup.date().required('Campo obbligatorio').nullable().typeError('Data non valida'),
    isForeign: yup.boolean(),
    // italian: yup.object().when('isForeign', {
    //   is: false,
    //   then: yup.object().shape({
    //     municipality: yup.object().nullable().required('Campo obbligatorio').shape({}),
    //   }),
    //   otherwise: yup.object().shape({
    //     municipality: yup.object().notRequired().nullable().shape({}),
    //   }),
    // }),
    // foreign: yup.object().when('isForeign', {
    //   is: true,
    //   then: yup.object().shape({
    //     municipality: yup.object().shape({}).nullable().required('Campo obbligatorio'),
    //     state: yup.object().shape({}).required('Campo obbligatorio').nullable(),
    //   }),
    //   otherwise: yup.object().shape({
    //     municipality: yup.object().shape({}).nullable().notRequired(),
    //     state: yup.object().shape({}).notRequired().nullable(),
    //   }),
    // }),
    from: yup
      .date()
      .nullable()
      .typeError('Data non valida')
      .min(DateTime.now().minus({ day: 1 }), 'La data non può essere inferiore alla data odierna'),
    // year: yup
    //   .string()
    //   .matches(regexYear, 'Il campo deve essere una data')
    //   .required('Campo obbligatorio'),
    // portion: yup
    //   .string()
    //   .required('Campo obbligatorio')
    //   .matches(portionRegex, 'Il campo non è valido'),
    // range: yup.string().matches(seriesRegex, 'Il campo non è valido'),
    // documentNumber: yup
    //   .string()
    //   .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri')
    //   .required('Campo obbligatorio'),
    // regVol: yup.string().matches(volumeRegex, 'Il campo non è valido'),
    // documentDate: yup.date().nullable().typeError('Data non valida'),
    actType: yup.string(),
    digital: yup
      .object()
      .nullable()
      .when('actType', {
        is: ActType.AttoDigitale,
        otherwise: yup.object().nullable(),
        then: yup
          .object()
          .nullable()
          .shape({
            idAnsc: yup
              .string()
              .nullable()
              .matches(idActRegex, 'Formato non corretto')
              .test((value) => {
                if (value) {
                  const [year] = value.split('-');
                  const isValid = year ? Number.parseInt(year) >= 2022 : true;

                  return isValid
                    ? true
                    : new yup.ValidationError(
                        "L'idAnsc deve avere anno maggiore al 2022",
                        undefined,
                        'marriage.digital.idAnsc'
                      );
                }
                return true;
              })
              .required('Campo obbligatorio'),
            documentDate: yup.date().nullable().notRequired().typeError('Formato non valido'),
            municipality: yup.object().shape({}).nullable().required('Campo obbligatorio'),
          })
          .test((values) => {
            const castedValues = values as unknown as DocumentDigital;

            if (
              castedValues?.municipality?.id &&
              castedValues?.istatCode &&
              castedValues?.municipality?.id === castedValues.istatCode
            ) {
              return true;
            }
            return new yup.ValidationError([
              new yup.ValidationError(
                'Non coincidono i due codici ISTAT',
                undefined,
                'widowhood.digital.municipality'
              ),
              new yup.ValidationError(
                'Non coincidono i due codici ISTAT',
                undefined,
                'widowhood.digital.istatCode'
              ),
            ]);
          }),
      }),
    paper: yup
      .object()
      .nullable()
      .when('actType', {
        is: ActType.AttoCartaceo,
        otherwise: yup.object().nullable(),
        then: yup.object().shape({
          actDate: yup
            .date()
            .nullable()
            .max(
              DateTime.local().plus({ days: 1 }),
              'La data non può essere successiva alla data odierna'
            )
            .typeError('Data non valida'),
          transcribed: yup.string().nullable(),
          actMunicipality: yup.object().nullable().shape({}).required('Campo obbligatorio'),
          actYear: yup
            .number()
            .nullable()
            .required('Campo obbligatorio')
            .typeError('Sono ammesse solamente cifre'),
          actNumber: yup
            .number()
            .nullable()
            .required('Campo obbligatorio')
            .typeError('Sono ammesse solamente cifre'),
          actPart: yup
            .string()
            .nullable()
            .required('Campo obbligatorio')
            .test(
              'part-ammisible-values',
              'Gli unici valori ammessi sono 1 o 2',
              (value) => ['1', '2'].indexOf(value || '') >= 0
            ),
          actSeries: yup.string().nullable(),
          // .required('Campo obbligatorio')
          // .test(
          //   'part-ammisible-values',
          //   'Gli unici valori ammessi sono A, B o C',
          //   (value) => ['A', 'B', 'C'].indexOf(value || '') >= 0
          // ),
          actVolume: yup
            .string()
            .nullable()
            .when('actMunicipality.description', {
              is: (description: string) => (description || '').toLocaleLowerCase() === 'milano',
              then: yup.string().required('Campo obbligatorio').matches(regVolRegex, {
                message: 'Per il comune di Milano il volume è formato da R e due cifre(es. R00)',
              }),
            }),
        }),
      }),
  });

export const voidCivilUnionSchema = yup
  .object()
  .nullable()
  .shape({
    // eventDate: yup.date().typeError('Data non valida').nullable().required('Il campo è obbligatorio'),
    // validityDate: yup.date().typeError('Data non valida').nullable().required('Il campo è obbligatorio'),
    // authority: yup.string().required('Campo obbligatorio').nullable(),
    // courtType: yup.string().nullable().required('Il campo è obbligatorio'),
    // municipality: yup.object().shape({}).nullable().required('Il campo è obbligatorio'),
    // year: yup
    //   .string()
    //   .matches(regexYear, 'Il campo deve essere una data')
    //   .required('Campo obbligatorio'),
    // number: yup.string().notRequired().nullable().matches(alphanumericRegex, 'Il campo non è valido'),
    // portion: yup
    //   .string()
    //   .required('Campo obbligatorio')
    //   .matches(alphanumericRegex, 'Il campo non è valido'),
    // range: yup.string().matches(alphanumericRegex, 'Il campo non è valido'),
    // documentNumber: yup
    //   .string()
    //   .matches(alphanumericRegex, 'Il campo può contenere solo lettere o numeri')
    //   .required('Campo obbligatorio'),
    // regVol: yup.string().matches(alphanumericRegex, 'Il campo non è valido'),
    // documentDate: yup.date().typeError('Data non valida').nullable(),
    number: yup
      .string()
      .nullable()
      .notRequired()
      .matches(regexalphaNumericWithDotSlash, 'Il campo non è valido'),
    eventDate: yup.date().typeError('Data non valida').nullable(),
    validityDate: yup.date().typeError('Data non valida').nullable(),
    authority: yup.string().nullable(),
    actType: yup.string(),
    digital: yup
      .object()
      .nullable()
      .when('actType', {
        is: ActType.AttoDigitale,
        otherwise: yup.object().nullable(),
        then: yup
          .object()
          .nullable()
          .shape({
            idAnsc: yup
              .string()
              .nullable()
              .matches(idActRegex, 'Formato non corretto')
              .test((value) => {
                if (value) {
                  const [year] = value.split('-');
                  const isValid = year ? Number.parseInt(year) >= 2022 : true;

                  return isValid
                    ? true
                    : new yup.ValidationError(
                        "L'idAnsc deve avere anno maggiore al 2022",
                        undefined,
                        'marriage.digital.idAnsc'
                      );
                }
                return true;
              })
              .required('Campo obbligatorio'),
            documentDate: yup.date().nullable().notRequired().typeError('Formato non valido'),
            municipality: yup.object().shape({}).nullable().required('Campo obbligatorio'),
          })
          .test((values) => {
            const castedValues = values as unknown as DocumentDigital;

            if (
              castedValues?.municipality?.id &&
              castedValues?.istatCode &&
              castedValues?.municipality?.id === castedValues.istatCode
            ) {
              return true;
            }
            return new yup.ValidationError([
              new yup.ValidationError(
                'Non coincidono i due codici ISTAT',
                undefined,
                'widowhood.digital.municipality'
              ),
              new yup.ValidationError(
                'Non coincidono i due codici ISTAT',
                undefined,
                'widowhood.digital.istatCode'
              ),
            ]);
          }),
      }),
    paper: yup
      .object()
      .nullable()
      .when('actType', {
        is: ActType.AttoCartaceo,
        otherwise: yup.object().nullable(),
        then: yup.object().shape({
          actDate: yup
            .date()
            .nullable()
            .max(
              DateTime.local().plus({ days: 1 }),
              'La data non può essere successiva alla data odierna'
            )
            .typeError('Data non valida'),
          transcribed: yup.string().nullable(),
          actMunicipality: yup.object().nullable().shape({}).required('Campo obbligatorio'),
          actYear: yup
            .number()
            .nullable()
            .required('Campo obbligatorio')
            .typeError('Sono ammesse solamente cifre'),
          actNumber: yup
            .number()
            .nullable()
            .required('Campo obbligatorio')
            .typeError('Sono ammesse solamente cifre'),
          actPart: yup
            .string()
            .nullable()
            .required('Campo obbligatorio')
            .test(
              'part-ammisible-values',
              'Gli unici valori ammessi sono 1 o 2',
              (value) => ['1', '2'].indexOf(value || '') >= 0
            ),
          actSeries: yup.string().nullable(),
          // .required('Campo obbligatorio')
          // .test(
          //   'part-ammisible-values',
          //   'Gli unici valori ammessi sono A, B o C',
          //   (value) => ['A', 'B', 'C'].indexOf(value || '') >= 0
          // ),
          actVolume: yup
            .string()
            .nullable()
            .when('actMunicipality.description', {
              is: (description: string) => (description || '').toLocaleLowerCase() === 'milano',
              then: yup.string().required('Campo obbligatorio').matches(regVolRegex, {
                message: 'Per il comune di Milano il volume è formato da R e due cifre(es. R00)',
              }),
            }),
        }),
      }),
  })
  .test('', '', (values) => {
    const castedValues = values as unknown as AccordionVoidCivilUnion;

    const errors = [];

    if (castedValues.type === '98') {
      return true;
    }

    if (!castedValues.eventDate) {
      errors.push(
        new yup.ValidationError('Il campo è obbligatorio', undefined, 'voidCivilUnion.eventDate')
      );
    }

    if (!castedValues.validityDate) {
      errors.push(
        new yup.ValidationError('Il campo è obbligatorio', undefined, 'voidCivilUnion.validityDate')
      );
    }

    if (!castedValues.authority) {
      errors.push(
        new yup.ValidationError('Il campo è obbligatorio', undefined, 'voidCivilUnion.authority')
      );
    }

    if (errors.length > 0) {
      return new yup.ValidationError(errors);
    }

    return true;
  });
